import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';




import { UtilService } from './util-service';
import { BemServico } from '../models/BemServico';

/*
  Generated class for the TiposIrregularidadesService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class BensServicosService {

  constructor(http: HttpClient,
              private utilService: UtilService) {
  }

  /*================================================================
  *
  *  Bens e Serviços Comuns
  *
  ==================================================================*/
  public criaBensServicos(){
    return new BemServico();
  }

  public listarBensServicos(): Observable<any> {
    let urlObtencaoDados: string = "bensServicos/listar";
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public buscarBemServico(idBensServicos): Observable<any> {
    let urlObtencaoDados: string = "bensServicos/obter/" + idBensServicos;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public salvarNovoBemServico(jsonObjeto): Observable<any> {
    let urlObtencaoDados: string = "bensServicos/salvar";
    return this.utilService.postJSON(urlObtencaoDados, jsonObjeto);
  }

  public deletarBensServicos(idBensServicos): Observable<any> {
    let urlObtencaoDados: string = "bensServicos/deletar/" + idBensServicos;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  /*================================================================
  *
  *  Tipos Bens e Serviços Comuns
  *
  ==================================================================*/
  public listarTipoBensServicos(): Observable<any> {
    let urlObtencaoDados: string = "bensServicos/listarTipos";
    return this.utilService.getJSON(urlObtencaoDados);
  }
}



// WEBPACK FOOTER //
// ./src/providers/bens-servicos-service.ts